import {IWHIJoinState} from '../../store';
import _get from 'lodash/get';
import type {FinancialDetails, CoverStartDate} from '@nib/types-session-api';

export const selectData = (state: IWHIJoinState): FinancialDetails => _get(state, 'session.session.financialDetails') || ({} as FinancialDetails);
export const getCoverStartDateData = (state: IWHIJoinState): CoverStartDate => selectData(state).coverStartDate || ({} as CoverStartDate);
export const getCoverEndDate = (state: IWHIJoinState): string | null => selectData(state).coverEndDate || null;
export const getCoverStartDate = (state: IWHIJoinState): string | null => getCoverStartDateData(state).date;
